/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdatePenaltyDetailsCommand } from '../../models/update-penalty-details-command';
import { UpdatePenaltyDetailsCommandResult } from '../../models/update-penalty-details-command-result';

export interface ApiPenaltyDetailsUpdatePenaltyDetailsPatch$Params {
      body?: UpdatePenaltyDetailsCommand
}

export function apiPenaltyDetailsUpdatePenaltyDetailsPatch(http: HttpClient, rootUrl: string, params?: ApiPenaltyDetailsUpdatePenaltyDetailsPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdatePenaltyDetailsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPenaltyDetailsUpdatePenaltyDetailsPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdatePenaltyDetailsCommandResult>;
    })
  );
}

apiPenaltyDetailsUpdatePenaltyDetailsPatch.PATH = '/api/PenaltyDetails/UpdatePenaltyDetails';
